<template>
  <section
    class="
      hero
      is-full-height is-flex is-align-content-center is-justify-content-center
      pd-small-touch
      pt-6
    "
  >
    <div class="hero-head">
      <div class="container has-text-centered">
        <p
          class="
            title
            has-text-white
            is-family-primary is-size-2-desktop is-size-3-touch
          "
        >
          TV Tweets
        </p>
        <h2
          class="
            subtitle
            has-text-left-touch
            is-family-primary
            has-text-center-desktop has-text-light
            is-size-3-desktop is-size-4-mobile
            pdx-small-touch pdx-small-desktop
            has-text-weight-semibold
            my-6
          "
        >
          What are the Most Stressful TV Shows to Watch?
        </h2>
        <p
          class="
            subtitle
            has-text-left-touch
            is-family-primary
            has-text-center-desktop has-text-light
            is-size-4-desktop is-size-5-mobile
            pdx-small-touch pdx-medium-desktop
            my-6
          "
        >
          Whether it’s the untimely death of a beloved character, or a
          nail-biting season finale, when television shocks us, we love to vent
          our emotions on Twitter. We’ve analysed the ‘stress levels’ in tweets
          to reveal which soap operas, reality shows and popular dramas cause
          the biggest stir among audiences.
        </p>
      </div>
    </div>
  </section>
</template>

<script>
  export default {};
</script>

<style lang="scss" scoped>
  @import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@500;600;700;800&display=swap");

  .hero {
    background-color: #000000;
    background-image: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 1, 1)),
      url("../assets/images/Component3.jpg");
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    min-height: 80vh;
  }

  .title {
    letter-spacing: 3px;
  }

  .has-background-primary {
    border-radius: 30px;
  }
</style>
